import {
  PODCAST_ID,
  STEPPER_NEXTPODCAST,
  SHOWPUBLISHERMODAL,
} from "redux/constants/PodCastContents";

const INITIAL_STATE = {
  stepActive: 0,
  podCastId: "",
  editShowPublisherModal: false,
};

const PodcastReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STEPPER_NEXTPODCAST:
      return { ...state, stepActive: action.payload };
    case PODCAST_ID:
      return { ...state, podCastId: action.payload };
    case SHOWPUBLISHERMODAL:
      return { ...state, editShowPublisherModal: action.payload };
    default:
      return state;
  }
};

export default PodcastReducers;
